<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <Banner />
        <Gmap />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Banner from "./Banner";
import Gmap from "./Gmap";
export default {
  components: {
    Banner,
    Gmap,
  },
};
</script>